import request from '@/utils/request'

export function userMenuList(params) {
  return request({
    url: '/business/notice/home/userMenuList',
    method: 'get',
    params,
  })
}
export function homeInfo(params) {
  return request({
    url: '/business/notice/home/homeInfo',
    method: 'get',
    params,
  })
}

export function addUserMenu(data) {
  return request({
    url: '/business/notice/home/addUserMenu',
    method: 'post',
    data: data,
  })
}

export function menuPathByMenuId(params) {
  return request({
    url: '/system/menu/menuPathByMenuId',
    method: 'get',
    params,
  })
}

export function downloadList(params) {
  return request({
    url: '/power/system/file/export/pageList',
    method: 'get',
    params,
  })
}

export function downloadLoading(data) {
  return request({
    url: '/power/system/file/loadingFileList',
    method: 'post',
    data: data,
  })
}
